import { useState } from "react";
import Editor from "./editor";

export default function PreviewSkill() {
    const [raw, setRaw] = useState(localStorage.getItem("previewSkills") || "");

    if(raw) {
        let parsed = null;
        try {
            parsed = JSON.parse(raw);
        }
        catch(e) {
            return <div className="w-100 p-3">
                <div className="alert alert-danger">Invalid JSON in <code>localStorage.previewSkills</code>: {e.message}</div>
                <button className="btn btn-secondary" onClick={() => { localStorage.removeItem("previewSkills"); setRaw(""); }}>Clear and start over</button>
            </div>
        }
        return <Editor data={{dynamicAIData: parsed}} />
    }

    const onChange = function(e) {
        const value = e.currentTarget.value;
        setRaw(value);
        localStorage.setItem("previewSkills", value);
    };

    return <div className="w-100 h-100 p-3" style={{minHeight:"100vh", boxSizing:"border-box"}}>
        <h5 className="mb-2">Paste block JSON</h5>
        <p className="text-muted small mb-2">Paste a <code>JSON.stringify(...)</code> of the block data here. It's saved to <code>localStorage.previewSkills</code> and the editor loads automatically.</p>
        <textarea
            className="form-control"
            style={{width:"100%", height:"calc(100vh - 140px)", fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace", fontSize:"13px"}}
            value={raw}
            onChange={onChange}
            placeholder='e.g. {"dynamicAIData":[ ... ]}'
            spellCheck={false}
        />
    </div>
}
